import type { TLandingFormFields } from 'entities/creditForm';

import { ContactsInfoTexts } from 'features/UpdateContactsInfo';
import { CreditPurposeInfoTexts } from 'features/UpdateCreditPurposeInfo';
import { PassportInfoTexts } from 'features/UpdatePassportInfo';

export const LandingInfoTexts: Record<keyof TLandingFormFields, string> = {
  ...ContactsInfoTexts,
  ...CreditPurposeInfoTexts,
  ...PassportInfoTexts,
};

export const SubmitButtonAuthText = 'Получить код';
export const SubmitButtonText = 'Продолжить';

export const EsiaTextsConfig = {
  title: 'Войдите через Госуслуги',
  subtitle: 'Покажем максимальную сумму, которую банки готовы вам одобрить',
  buttonTitle: 'Войти через Госуслуги',
};

export const StepsLabels = {
  creditPurpose: 'Цель кредита',
  contacts: 'Контактные данные',
};
